export default __webpack_public_path__ + "static/media/assessment-form-clip.20907b0c.svg";